<template>
  <!-- <div class="job-card">
    <div class="card-header">
      <div class="job-info">
        <div class="image_wrapper" data-testid="directions-3">
          <el-avatar :size="'small'" shape="square" :src="userData.image" v-if="userData.image" />
          <el-avatar :size="'small'" class="avatar-d" shape="square"
            icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
        </div>
        <div class="job-detail">
          <div class="job-title">{{ job.title }}</div>
          <div class="job-poster">{{ userData.firstName }}</div>
          <div class="job-poster">
            {{ userData.billing.address.text }}
          </div>
          <div class="job-poster">
            {{ job.category }}
          </div>

        </div>
        <div class="job-type-label-container">
          <div class="job-type-label" :class="getClass(job.jobStatus)">{{ job.jobStatus }}</div>
          <div class="job-type-label" :class="job.type">{{ job.type }}</div>
        </div>
      </div>
    </div>

    <div class="card-content">
      <div v-if="!isCardExpanded">
        {{ job.shortDescription }}...
      </div>
      <div v-else>
        <div v-show="isCardExpanded" v-html="job.description">
      </div>
        <div class="job-applicants">
        <ul class="job-applicants-list">
          <h4>Applicants</h4><div v-for="(applicant, index) in job.applicants" :key="index">
              <li class="job-applicant-single">
            <div class="image-wrapper">
              <el-avatar :size="'small'" class="avatar-job" shape="square" :src="applicant.applicant.image" v-if="applicant.applicant.image" />
              <el-avatar v-else :size="'small'" class="avatar-job" shape="square"
                icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"></el-avatar>
            </div>
            <div class="job-applicant-info">
              <div class="job-applicant-name">{{  applicant.applicant.name}}</div>
              <div class="job-applicant-address">{{ applicant.applicant.address }}</div>
            </div>
            <div class="job-applicant-status">
              <span class="job-type-label" :class="getClass( applicant.status)">{{ applicant.status }}</span>
            </div>
          </li>
            </div>
        </ul>
      </div>
      </div>
     
  


    </div>
    <div class="job-detail-link" data-testid="directions-6" @click="toggleCard">
      <button class="link-button"><span>{{ isCardExpanded ? 'Read Less' : 'Read More' }}</span>
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"
          v-if="isCardExpanded">
          <path
            d="M11.2837 8.11526L5.36238 2.47339C5.26358 2.3792 5.13232 2.32666 4.99582 2.32666C4.85932 2.32666 4.72805 2.3792 4.62926 2.47339L4.62288 2.47976C4.57482 2.52542 4.53655 2.58038 4.51039 2.6413C4.48424 2.70221 4.47076 2.76781 4.47076 2.8341C4.47076 2.9004 4.48424 2.966 4.51039 3.02691C4.53655 3.08783 4.57482 3.14279 4.62288 3.18845L10.1989 8.50095L4.62288 13.8113C4.57482 13.857 4.53655 13.9119 4.51039 13.9729C4.48424 14.0338 4.47076 14.0994 4.47076 14.1657C4.47076 14.232 4.48424 14.2976 4.51039 14.3585C4.53655 14.4194 4.57482 14.4744 4.62288 14.52L4.62925 14.5264C4.72805 14.6206 4.85932 14.6731 4.99582 14.6731C5.13232 14.6731 5.26358 14.6206 5.36238 14.5264L11.2837 8.88451C11.3358 8.8349 11.3772 8.77522 11.4056 8.70911C11.4339 8.64299 11.4485 8.57181 11.4485 8.49989C11.4485 8.42796 11.4339 8.35678 11.4056 8.29067C11.3772 8.22455 11.3358 8.16488 11.2837 8.11526Z"
            fill="#808080" style="transform: rotate(-90deg); transform-origin: center;" />
        </svg>
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
          <path
            d="M11.2837 8.11526L5.36238 2.47339C5.26358 2.3792 5.13232 2.32666 4.99582 2.32666C4.85932 2.32666 4.72805 2.3792 4.62926 2.47339L4.62288 2.47976C4.57482 2.52542 4.53655 2.58038 4.51039 2.6413C4.48424 2.70221 4.47076 2.76781 4.47076 2.8341C4.47076 2.9004 4.48424 2.966 4.51039 3.02691C4.53655 3.08783 4.57482 3.14279 4.62288 3.18845L10.1989 8.50095L4.62288 13.8113C4.57482 13.857 4.53655 13.9119 4.51039 13.9729C4.48424 14.0338 4.47076 14.0994 4.47076 14.1657C4.47076 14.232 4.48424 14.2976 4.51039 14.3585C4.53655 14.4194 4.57482 14.4744 4.62288 14.52L4.62925 14.5264C4.72805 14.6206 4.85932 14.6731 4.99582 14.6731C5.13232 14.6731 5.26358 14.6206 5.36238 14.5264L11.2837 8.88451C11.3358 8.8349 11.3772 8.77522 11.4056 8.70911C11.4339 8.64299 11.4485 8.57181 11.4485 8.49989C11.4485 8.42796 11.4339 8.35678 11.4056 8.29067C11.3772 8.22455 11.3358 8.16488 11.2837 8.11526Z"
            fill="#808080" style="transform: rotate(90deg); transform-origin: center;" />
        </svg>
      </button>
    </div>
  </div> -->

  <div class="job-results">
    <div class="result-item-wrapper">
      <div class="result-item">
        <div class="job-info">
          <div class="job-image-title">
            <div class="image_wrapper" data-testid="directions-64">
              <el-avatar :size="'small'" shape="square" :src="userData.image" v-if="userData.image" />
              <el-avatar :size="'small'" class="avatar-job" shape="square"
                icon="locumate_icons locumate_icon-user1 locumate_icons-avatar" v-else></el-avatar>
            </div>
            <div class="job-detail-main">
              <div class="job-title">{{ job.title }}</div>
              <div class="job-poster">{{ job.platformRoleName }}</div>
            </div>
          </div>
        </div>
        <div class="job-detail-row-item">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.9999 11.1917C11.4358 11.1917 12.5999 10.0276 12.5999 8.5917C12.5999 7.15576 11.4358 5.9917 9.9999 5.9917C8.56396 5.9917 7.3999 7.15576 7.3999 8.5917C7.3999 10.0276 8.56396 11.1917 9.9999 11.1917Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
            <path
              d="M3.01675 7.07484C4.65842 -0.141827 15.3501 -0.133494 16.9834 7.08317C17.9418 11.3165 15.3084 14.8998 13.0001 17.1165C11.3251 18.7332 8.67508 18.7332 6.99175 17.1165C4.69175 14.8998 2.05842 11.3082 3.01675 7.07484Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" />
          </svg>
          <div class="job-detail-text">
            {{ job.location }}
          </div>
        </div>

        <div class="job-detail-row-item">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.3334 9.99984C18.3334 14.5998 14.6001 18.3332 10.0001 18.3332C5.40008 18.3332 1.66675 14.5998 1.66675 9.99984C1.66675 5.39984 5.40008 1.6665 10.0001 1.6665C14.6001 1.6665 18.3334 5.39984 18.3334 9.99984Z"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
            <path d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8416 9.69165 10.2 9.69165 9.67497V6.2583"
              stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>

          <div class="job-detail-text">
            {{ job.type }}
          </div>

          <div class="job-detail-link ml-auto" v-if="job.description"
            :class="{ stickToBottom: isCardExpanded === true }" data-testid="directions-6" @click="toggleCard">
            <button class="text-only">
              {{ isCardExpanded ? "Read Less" : "Read More" }}
            </button>
          </div>
        </div>

        <div class="badge-wrapper">
          <div class="badge-pharmacy cursor-pointer federal-support" v-if="job.federalPharmacistSupport && isUS">

<div v-if="job.federalPharmacistSupport === 1">Federal Pharmacist Support</div>
</div>
          <div class="badge-pharmacy" :class="getClass(job.jobStatus)"
            @click="isJobApplied ? showJobApplicants(job.id) : () => ''">
            {{ job.jobStatus }}
          </div>
         
        </div>

        <div class="card-content" v-show="isCardExpanded">
          <!-- <div v-if="!isCardExpanded">
            {{ job.shortDescription }}...
          </div> -->
          <div v-html="job.description"></div>

          <div class="job-applicants" v-if="job.applicants.length > 0">
            <ul class="job-applicants-list">
              <h4>Applicants</h4>
              <!-- <div v-for="(applicant, index) in job.applicants" :key="index">
                <li class="job-applicant-single">
                  <div class="image-wrapper">
                    <el-avatar :size="'small'" class="avatar-job" shape="square" :src="applicant.applicant.image"
                      v-if="applicant.applicant.image" />
                    <el-avatar v-else :size="'small'" class="avatar-job" shape="square"
                      icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"></el-avatar>
                  </div>
                  <div class="job-applicant-info">
                    <div class="job-applicant-name">{{ applicant.applicant.name }}</div>
                    <div class="job-applicant-address">{{ applicant.applicant.address }}</div>
                  </div>
                  <div class="job-applicant-status">
                    <span class="job-type-label" :class="getClass(applicant.status)">{{ applicant.status }}</span>
                  </div>
                </li>
              </div> -->

              <div v-for="(applicant, index) in job.applicants" :key="index"
                class="card-wrapper inside-notify categorized">
                <div class="applicant-row">
                  <div class="image_wrapper">
                    <el-avatar :size="'small'" class="avatar-job" shape="square" :src="applicant.applicant.image"
                      v-if="applicant.applicant.image" />
                    <el-avatar v-else :size="'small'" class="avatar-job" shape="square"
                      icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"></el-avatar>
                  </div>
                  <div class="applicant-info">
                    <div class="applicant-name">
                      {{ applicant.applicant.name }}
                    </div>
                    <div class="applicant-job-type" :class="getClass(applicant.status)">
                      {{ applicant.status }}
                    </div>
                  </div>
                </div>
                <div class="address-row">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.9999 11.1912C11.4358 11.1912 12.5999 10.0272 12.5999 8.59121C12.5999 7.15527 11.4358 5.99121 9.9999 5.99121C8.56396 5.99121 7.3999 7.15527 7.3999 8.59121C7.3999 10.0272 8.56396 11.1912 9.9999 11.1912Z"
                      stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"></path>
                    <path
                      d="M3.01675 7.07533C4.65842 -0.141339 15.3501 -0.133006 16.9834 7.08366C17.9418 11.317 15.3084 14.9003 13.0001 17.117C11.3251 18.7337 8.67508 18.7337 6.99175 17.117C4.69175 14.9003 2.05842 11.3087 3.01675 7.07533Z"
                      stroke="rgb(var(--locumate-primary-color))" stroke-width="1.5"></path>
                  </svg>
                  <div class="address">{{ applicant.applicant.address }}</div>
                </div>
                <!--v-if-->
                <div class="badge-wrapper">
                  <div class="badge-pharmacy" :class="getClass(applicant.status)">
                    {{ applicant.status }}
                  </div>
                </div>
              </div>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <el-drawer custom-class="bottom_drop_up" v-model="bottomDropUp" :append-to-body="true" :with-header="false"
    :direction="'btt'" :destroy-on-close="true">
    <el-button type="transparent" class="menu_item" data-testid="directions-7" @click="sendReport()">
      <img src="@/assets/img/job-seeker/edit.svg" height="18" alt="" />
      Edit
    </el-button>
    <el-button type="transparent" class="menu_item" data-testid="directions-8" @click="sendReport()">
      <img src="@/assets/img/job-seeker/archive.svg" height="18" alt="" />
      Archive
    </el-button>
    <el-button type="transparent" class="menu_item" data-testid="directions-9" @click="withdrawJob()">
      <img src="@/assets/img/job-seeker/withdraw.svg" height="18" alt="" />
      Withdraw
    </el-button>
  </el-drawer> -->
</template>

<script>
import { ref, computed, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessageBox, ElMessage } from "@/components/Vendor/Element";
import {  isUSRegion } from '@/helpers/region/regionHelper.js';

export default {
  props: {
    job: Object,
  },
  setup(props) {
    const expandedCard = ref(null);
    const $store = useStore();
    const $router = useRouter();
    const userData = $store.getters.GET_USER_DATA;
    const instance = getCurrentInstance();
    console.log("🚀 ~ setup ~ userData:", userData);
    const toggleCard = () => {
      if (expandedCard.value === props.job.id) {
        expandedCard.value = null;
      } else {
        expandedCard.value = props.job.id;
      }
    };
    const bottomDropUp = ref(false);
    const isCardExpanded = computed(() => {
      return expandedCard.value === props.job.id;
    });
    const isUS = isUSRegion();

    const showJobApplicants = (jobId) => {
      console.log("🚀 ~ showDetail ~ jobId:", jobId);

      $router.push({
        name: "job_poster_applicants_list",
        params: { jobId: jobId }, // Assuming job object has an 'id' property
      });
    };

    // Computed property to check if job_status is "1 Applied"
    const isJobApplied = computed(() => {
      return props.job.jobStatus.toLowerCase().includes("applied");
    });

    const getShortenedDescription = (description) => {
      const words = description.split(/\s+/);
      return words.length > 20 ? words.slice(0, 20).join(" ") : description;
    };

    const isDescriptionOverflow = (description) => {
      return description.split(/\s+/).length > 20;
    };

    const bottomDropUpExist = () => {
      return true;
    };

    const sendReport = () => {
      bottomDropUp.value = false;
    };
    const getClass = (status) => {
      // Convert the status to lowercase for case-insensitive comparison
      const lowercaseStatus = status.toLowerCase();

      // Return class based on status
      return lowercaseStatus;
    };
    const withdrawJob = async () => {
      const { value: reason } = await ElMessageBox.prompt(
        `Are you sure you want to withdraw the job?`,
        "Withdraw Job",
        {
          confirmButtonText: "Withdraw",
          cancelButtonText: "Cancel",
          confirmButtonClass: "el-button--primary",
          cancelButtonClass: "el-button--grey",
          showClose: false,
          inputPattern: /\S.{9,}/,
          inputErrorMessage: "Please provide withdraw reason. (10 char min)",
        }
      );

      await (async () => {
        try {
          const response = await $store.dispatch("WITHDRAW_JOB_POST", {
            jobPostId: props.job.id,
            payload: {
              reason: reason,
            },
          });

          if (response.data.success) {
            ElMessage({
              type: "success",
              message: response.data.message,
            });

            // Emit an event to refresh the job list
            instance.emit("refresh-job-list");
            console.log("refresh-job-list emitted");
            // TODO: Refresh the job list
          } else {
            ElMessage({
              type: "info",
              message: response.data.message,
            });
          }
          bottomDropUp.value = false;
        } catch (error) {
          ElMessage({
            type: "error",
            message: error.withdrawn_reason[0],
          });
        }
      })();
    };

    return {
      toggleCard,
      isCardExpanded,
      getShortenedDescription,
      isDescriptionOverflow,
      userData,
      bottomDropUpExist,
      bottomDropUp,
      sendReport,
      isJobApplied,
      showJobApplicants,
      withdrawJob,
      getClass,
      isUS
    };
  },
};
</script>
